import React from "react";
import img1 from "../../assets/img/hosting/hosting-1.svg";
import img2 from "../../assets/img/hosting/hosting-2.svg";
import img3 from "../../assets/img/hosting/hosting-3.svg";
import img4 from "../../assets/img/hosting/hosting-4.svg";
import Button from "../shared/Button";
const HostinginJatick = ({nextStep}) => {
  return (
    <div className="HostinginJatick">
    <div className="container">
    <div className="flex gap-[108] HostinginJatick-first-row">
        <div>
          <img src={img1} />
          <div className="flex gap-[20px] mt-[40px]">
            <img src={img3} />
            <img src={img2} />
          </div>
        </div>
        <div className=" HostinginJatick-first-row--info">
          <h4>چرا در جاتیک میزبان بشم ؟</h4>
          <p>
            ثبت اقامت در سایت رزرواسیون اقامتگاه‌های گردشگری جاتیک، باعث افزایش
            قابل توجه تعداد مشتریان و مهمانان شما می‌شود. این سایت، به شما امکان
            می‌دهد تا اقامتگاه خود را به صورت آنلاین و به صورت جهانی به نمایش
            بگذارید.
          </p>
          <Button varient="primary">آموزش میزبانی در جاتیک</Button>
        </div>
      </div>
      <div className="HostinginJatick-first-row  gap-[102]" >
          <div className="HostinginJatick-sec-row--info">
          <h4>چرا در جاتیک میزبان بشم ؟</h4>
          <p>
            ثبت اقامت در سایت رزرواسیون اقامتگاه‌های گردشگری جاتیک، باعث افزایش
            قابل توجه تعداد مشتریان و مهمانان شما می‌شود. این سایت، به شما امکان
            می‌دهد تا اقامتگاه خود را به صورت آنلاین و به صورت جهانی به نمایش
            بگذارید.
          </p>
          </div>
        <img src={img4}/>
      </div>
    <div className="center">
    <Button onClick={()=>nextStep(2)} varient="fifth">ادامه فرایند</Button>
    </div>
    </div>
    </div>
  );
};

export default HostinginJatick;
